// extracted by mini-css-extract-plugin
export default {"virtuosoContainer":"GradesList__virtuosoContainer___jk5UU","gradeRow":"GradesList__gradeRow___UJMjL"};